import {
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { ControlPoint, LockOpenSharp, LockSharp } from "@material-ui/icons";
import CropRotateIcon from "@material-ui/icons/CropRotate";
import LockIcon from "@material-ui/icons/Lock";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import TableComponent from "app/common/Component/Table/TableComponent";
import IconMedicalHistory from "app/common/Icon/EyeTestTabs/IconMedicalHistory";
import IconDelete from "app/common/Icon/IconDelete";
import IconEye from "app/common/Icon/IconEye";
import IconPen from "app/common/Icon/IconPen";
import { ACTIVE_STATUS, LOCKED_STATUS } from "app/common/LocalConst";
import {
  checkPaymentMethodLimits,
  formatMoney,
  formatNumber,
  getDateTime,
  isAdmin,
  isDoctor,
  isRoleBranchManager,
  isRoleCashier,
  isRoleChiefTechician,
  isRoleHisAccountant,
  isRoleHisReadOnly,
  isRoleManualExchange,
  isRoleTechician,
  isSalesConsultant,
} from "app/common/LocalFunction";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import { memo, useState } from "react";
import { useTranslation } from "react-i18next";

const ListRegisterCard = () => {
  const { t } = useTranslation();

  const {
    handleOpenCreateOrEditCardPopup,
    handleChangeFormSearchService,
    pageRegisterCard,
    searchRegisterCard,
    handleOpenConfirmDelete,
    handleOpenHistoryCardPopup,
    handleOpenChangeCardPopup,
    handleOpenConfirmlock,
    handleOpenConfirmUnlock,
    handleOpenHistoryMongoCardPopup,
  } = useStore().patientManagementStore.registerCardStore;
  const {
    handleOpenHistoryStaffRevenuePopup,
    initialPatient,
    customerSourceWalkIn,
  } = useStore().patientManagementStore.patientGeneralStore;

  const {
    handleOpenTotalBillStatusInvoiceItemConfirm,
    handleOpenPaymentVoucherPopup,
    handleOpenFormLockRetaind,
  } = useStore().feeStore.serviceFeeTabStore;
  const { values, setFieldValue } = useFormikContext();

  function handleSetListChosenCards(newList) {
    setFieldValue("chosenCards", newList || []);
  }
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const isReadonly = isRoleHisReadOnly();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleMenuOpen = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowData);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };
  let isAdminPermission = isAdmin();
  const isRoleCashierPermission = isRoleCashier();
  const isRoleBranchManagerPermission = isRoleBranchManager();
  const isSalesConsultantPermission = isSalesConsultant();
  const isRoleCt = isRoleTechician() || isRoleChiefTechician();
  const isDoctors = isDoctor();
  const isAccountant = isRoleHisAccountant();

  const hasAddPermission =
    isAdminPermission ||
    isRoleCashierPermission ||
    isAccountant ||
    isRoleBranchManagerPermission;
  const isManualExchange = isRoleManualExchange();
  const canManualExchange = isAdminPermission || isManualExchange;
  return (
    <Grid
      container
      spacing={1}
      className="justify-center cards-body pt-0 mt-2"
      style={{
        zIndex: 1,
        position: "relative",
      }}
    >
      <Grid item xs={12}>
        <TableComponent
          showOrdinalNumbers
          titleNodata={t("noData")}
          data={pageRegisterCard?.content || []}
          // doubleClick={(patient) => {
          //   handleOpenCreateOrEditCardPopup(patient);
          // }}
          minWidth={"820px"}
          name="ListRegisterCard"
          showMoreButton
          {...(!isMobile ||
            (!isReadonly && {
              selectType: "multi",
              handleChangeSelectedRows: handleSetListChosenCards,
            }))}
          maxHeight={"520px"}
          columns={[
            {
              title: t("Tạo phiếu chi"),
              field: "action",
              width: "70px",
              render: (row) => {
                const isLocked = row?.activeStatus === LOCKED_STATUS;
                return (
                  <div className="flex-center gap-2">
                    {hasAddPermission && (
                      <>
                        {!isLocked && (
                          <Tooltip title={"Tạo phiếu chi"}>
                            <div
                              onClick={() => {
                                let staffRevenues = row?.staffRevenues?.map(
                                  (el) => ({ ...el, id: null })
                                );

                                handleOpenPaymentVoucherPopup(
                                  initialPatient?.patientInfo,
                                  null,
                                  customerSourceWalkIn,
                                  {
                                    treatmentPlanCard: row,
                                    totalAmount: row?.totalBillPatientPaid || 0,
                                    staffRevenues: staffRevenues,
                                  }
                                );
                              }}
                              className="mr-1 flex"
                            >
                              <ControlPoint
                                style={{
                                  color: "#3f51b5",
                                  fontSize: "22px",
                                }}
                              />
                            </div>
                          </Tooltip>
                        )}
                      </>
                    )}
                  </div>
                );
              },
            },
            hasAddPermission && {
              title: t("action"),
              field: "action",
              align: "center",
              width: "70px",
              render: (row) => {
                const isLocked = row?.cardStatus === 2;
                return (
                  <>
                    <div className="flex-center gap-2 cursor">
                      <Tooltip
                        title={
                          isLocked
                            ? "Thẻ đã bị khóa - không thể chỉnh sửa"
                            : "Chỉnh sửa"
                        }
                      >
                        <div
                          onClick={
                            !isLocked
                              ? () => handleOpenCreateOrEditCardPopup(row)
                              : undefined
                          }
                          style={{
                            cursor: isLocked ? "not-allowed" : "pointer",
                            opacity: isLocked ? 0.5 : 1,
                          }}
                        >
                          <IconPen />
                        </div>
                      </Tooltip>
                      {canManualExchange && (
                        <Tooltip
                          title={
                            isLocked
                              ? "Thẻ đã bị khóa - không thể đổi thẻ"
                              : "Đổi thẻ"
                          }
                        >
                          <div
                            onClick={
                              !isLocked
                                ? () => handleOpenChangeCardPopup(row, initialPatient?.patientInfo,)
                                : undefined
                            }
                            style={{
                              cursor: isLocked ? "not-allowed" : "pointer",
                              opacity: isLocked ? 0.5 : 1,
                            }}
                          >
                            <SyncAltIcon color="primary" />
                          </div>
                        </Tooltip>
                      )}
                      <Tooltip
                        title={
                          isLocked ? "Thẻ đã bị khóa - không thể xóa" : "Xóa"
                        }
                      >
                        <div
                          className="flex"
                          onClick={
                            row?.cardStatus !== 2
                              ? () => handleOpenConfirmDelete(row?.id)
                              : undefined
                          }
                          style={{
                            cursor: isLocked ? "not-allowed" : "pointer",
                            opacity: isLocked ? 0.5 : 1,
                          }}
                        >
                          <IconDelete />
                        </div>
                      </Tooltip>
                      <Tooltip title="Xem lịch sử">
                        <div
                          onClick={() => {
                            handleOpenHistoryCardPopup(row?.id);
                          }}
                        >
                          <IconEye />
                        </div>
                      </Tooltip>
                      <Tooltip title="Tùy chọn">
                        <IconButton
                          size="small"
                          onClick={(e) => handleMenuOpen(e, row)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                    <Menu
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl) && selectedRow?.id === row?.id}
                      onClose={handleMenuClose}
                      PaperProps={{
                        style: {
                          boxShadow: "none",
                        },
                      }}
                    >
                      {!isLocked && (
                        <MenuItem>
                          <Tooltip title={"Khóa"}>
                            <div
                              onClick={() => {
                                handleOpenConfirmlock(row?.id);
                                handleMenuClose();
                              }}
                              style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                              }}
                            >
                              <LockSharp
                                style={{
                                  color: "#3f51b5",
                                  fontSize: "22px",
                                }}
                              />
                              <span>Khóa</span>
                            </div>
                          </Tooltip>
                        </MenuItem>
                      )}
                      {!isLocked && (
                        <MenuItem>
                          <Tooltip title={"Khóa và lưu trữ số dư"}>
                            <div
                              onClick={() => {
                                handleOpenFormLockRetaind(row);
                                handleMenuClose();
                              }}
                              style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                              }}
                            >
                              <LockSharp
                                style={{
                                  color: "#3f51b5",
                                  fontSize: "22px",
                                }}
                              />
                              <span>Khóa và lưu trữ số dư</span>
                            </div>
                          </Tooltip>
                        </MenuItem>
                      )}

                      <MenuItem>
                        {isLocked && (
                          <Tooltip title={"Mở khóa"}>
                            <div
                              onClick={() => {
                                handleOpenConfirmUnlock(row?.id);
                                handleMenuClose();
                              }}
                              style={{
                                display: "flex",
                                gap: "10px",
                                alignItems: "center",
                              }}
                            >
                              <LockOpenSharp
                                style={{
                                  color: "#3f51b5",
                                  fontSize: "22px",
                                  marginRight: 8,
                                }}
                              />
                              <span>Mở khóa</span>
                            </div>
                          </Tooltip>
                        )}
                      </MenuItem>
                      {isAdminPermission && row?.currentInvoiceItemId && (
                        <MenuItem>
                          <Tooltip
                            title={
                              "Tính số tiền và cập nhật trạng thái thanh toán "
                            }
                          >
                            <div
                              onClick={() => {
                                handleOpenTotalBillStatusInvoiceItemConfirm(
                                  row?.currentInvoiceItemId
                                );
                                handleMenuClose();
                              }}
                              className="flex gap-1 align-center"
                            >
                              <CropRotateIcon color="primary" />
                              <span>
                                Tính số tiền và cập nhật trạng thái thanh toán{" "}
                              </span>
                            </div>
                          </Tooltip>
                        </MenuItem>
                      )}

                      <MenuItem
                        onClick={() => {
                          handleOpenHistoryMongoCardPopup({ id: row?.id });
                          handleMenuClose();
                        }}
                      >
                        <Tooltip title="Xem lịch sử">
                          <div className="flex gap-1 align-center">
                            <IconMedicalHistory
                              style={{ width: "18px", marginRight: 8 }}
                              color="blue"
                            />
                            <span>Xem lịch sử thẻ</span>
                          </div>
                        </Tooltip>
                      </MenuItem>

                      <MenuItem
                        onClick={() => {
                          handleMenuClose();
                          handleOpenHistoryStaffRevenuePopup({
                            // id:row?.id,
                            treatmentPlanCardId: row?.id,
                          });
                        }}
                      >
                        <Tooltip title="Xem lịch sử phân bổ">
                          <div className="flex gap-1 align-center">
                            <IconMedicalHistory
                              style={{ width: "18px", marginRight: 8 }}
                              color="blue"
                            />
                            <span>Xem lịch sử phân bổ</span>
                          </div>
                        </Tooltip>
                      </MenuItem>
                    </Menu>
                  </>
                );
              },
            },
            {
              title: t("Mã đơn hàng"),
              field: "code",
            },
            {
              field: "clientCard.code",
              title: t("Mã thẻ trả trước"),
              render: (val) => {
                return (
                  <div>
                    <span className="service-code">
                      {val?.clientCard?.code}
                    </span>
                  </div>
                );
              },
            },
            {
              field: "clientCard.name",
              title: t("Tên thẻ trả trước"),
              render: (val) => {
                const isLocked = val?.cardStatus === 2;
                return (
                  <div>
                    <span
                      className="service-name"
                      onClick={() => {
                        if (!isLocked) {
                          handleOpenCreateOrEditCardPopup(val);
                        }
                      }}
                    >
                      {checkPaymentMethodLimits()
                        ? val?.clientCard?.registeredName ||
                        val?.clientCard?.name
                        : val?.clientCard?.name}
                    </span>
                    <div>
                      Giá trị SD:{" "}
                      <b style={{ color: "green" }}>
                        {formatMoney(val?.totalValueRegister || 0)}
                      </b>
                    </div>
                    <div className="flex">
                      <div>
                        Đã thu:{" "}
                        <b style={{ color: "green" }}>
                          {formatMoney(val?.totalBillPatientPaid || 0)}
                        </b>
                      </div>
                      <span className="mx-2 text-gray-400">|</span>
                      <div>
                        Cần thu:{" "}
                        <b style={{ color: "red" }}>
                          {formatMoney(val?.amountActuallyPaid)}
                        </b>
                      </div>
                    </div>
                  </div>
                );
              },
            },
            {
              field: "price",
              title: "Giá tiền",
              align: "right",
              render: (val) => formatMoney(val?.price),
            },
            {
              field: "quantity",
              title: t("Số lượng"),
              align: "right",
            },

            {
              field: "practitioner.staffName",
              title: t("Thành tiền"),
              width: "240px",
              render: (data) => {
                return (
                  <div className="total-data-group">
                    <div className="flex justify-between">
                      Tổng tiền:{" "}
                      <b>{formatMoney(data?.price * data?.quantity)}</b>
                    </div>
                    <div className="flex justify-between">
                      Giảm giá: <b>{formatMoney(data?.discount)}</b>
                    </div>

                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Số tiền (sau giảm):{" "}
                        <b>
                          {formatMoney(
                            data?.price * data?.quantity -
                            (+data?.discount || 0)
                          )}
                        </b>
                      </b>
                    </div>
                    {data?.allocateDiscount ? (
                      <div>
                        <b
                          className="flex justify-between"
                          style={{ width: "100%" }}
                        >
                          Giảm tổng HĐ:{" "}
                          <b>{formatMoney(data?.allocateDiscount)}</b>
                        </b>
                      </div>
                    ) : (
                      <></>
                    )}
                    {/* <div className="flex justify-between">
                      Vat: <b>{formatMoney(+data?.taxTotal)}</b>
                    </div> */}
                    {data?.oldTreatmentPlanCard?.oldTreatmentCredit && (
                      <div className="flex justify-between">
                        Tiền khấu trừ từ lt cũ:{" "}
                        <b>
                          {formatMoney(
                            +data?.oldTreatmentPlanCard?.oldTreatmentCredit
                          )}
                        </b>
                      </div>
                    )}
                    <div
                      style={{
                        background: "#ccc",
                        width: "100%",
                        height: "1px",
                        margin: "4px 0",
                      }}
                    ></div>
                    <div className="flex justify-between">
                      <b
                        className="flex justify-between"
                        style={{ width: "100%" }}
                      >
                        Tổng thanh toán:{" "}
                        <b>{formatMoney(+data?.amountActuallyPaid || 0)}</b>
                      </b>
                    </div>
                  </div>
                );
              },
            },
            // {
            //   field: "clientCard.name",
            //   title: t("Ngày đăng ký"),
            //   render: (val) => getDateTime(val?.orderDate),
            // },
            {
              field: "totalValue",
              title: t("Giá trị được sử dụng"),
              render: (val) => formatMoney(val?.totalValue),
            },
            {
              field: "totalUsed",
              title: t("Giá trị đã sử dụng"),
              render: (val) => formatMoney(val?.totalUsed),
            },
            {
              field: "totalUsed",
              title: t("Số tiền còn lại"),
              render: (val) =>
                formatMoney(val?.totalValue - (val?.totalUsed || 0)),
            },
            {
              field: "clientCard.name",
              title: t("Doanh thu phân bổ(nhân viên)"),
              width: "550px",
              render: (val) => {
                return (
                  <>
                    {val?.staffRevenues?.map((staffRevenue, index) => (
                      <div
                        key={index}
                        className="revenue-item"
                        style={{
                          display: "flex",
                          fontSize: isMobile ? 12 : 14,
                          marginBottom: 6,
                          padding: "4px 0",
                          borderBottom: "1px solid gray",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          <span className="revenue-percent">
                            {staffRevenue?.source?.name} -{" "}
                          </span>
                          <span className="position">
                            {" "}
                            {staffRevenue?.position?.name} -{" "}
                          </span>
                        </div>
                        <div>
                          <b className="staff-name">
                            {staffRevenue?.staff?.staffName}
                          </b>
                          <i className="revenue-percent">
                            {staffRevenue?.actualAmount && (
                              <span className="label-primary-number">
                                {formatMoney(staffRevenue?.actualAmount)}
                                {"-"}
                              </span>
                            )}
                            {formatNumber(staffRevenue?.percentRevenue) + "%"}
                          </i>
                        </div>
                      </div>
                    ))}
                  </>
                );
              },
            },

            {
              field: "clientCard.name",
              title: t("Ngày đăng ký"),
              render: (val) => getDateTime(val?.startDate),
            },
            {
              field: "clientCard.name",
              title: t("Ngày hết hạn sử dụng"),
              render: (val) => getDateTime(val?.endDate),
            },

            // {
            //   field: "discount",
            //   title: t("Tiền giảm giá"),
            //   render: (val) => formatMoney(val?.discount),
            // },
            {
              field: "department.name",
              title: t("Cơ sở"),
            },
            // {
            //   field: "patient",
            //   title: t("Nguồn"),
            //   render: (row) => {
            //     const sourceName = row?.source?.name;
            //     const sourceDetailName = row?.sourceDetail?.name;
            //     return (
            //       <>
            //         <div>
            //           <div>
            //             {sourceName ? `Nguồn hiện tại: ${sourceName}` : ""}
            //           </div>
            //           <div>
            //             {sourceDetailName
            //               ? `Nguồn chi tiết: ${sourceDetailName}`
            //               : ""}
            //           </div>
            //         </div>
            //       </>
            //     );
            //   },
            // },
            {
              field: "activeStatus",
              title: t("Trạng thái"),
              render: (row) => (
                <div style={{ textAlign: "center" }}>
                  {row?.cardStatus === ACTIVE_STATUS ? (
                    <Tooltip title="Đang mở">
                      <LockOpenIcon />
                    </Tooltip>
                  ) : row?.cardStatus === LOCKED_STATUS ? (
                    <Tooltip title="Đã khóa">
                      <LockIcon />
                    </Tooltip>
                  ) : (
                    ""
                  )}
                  {row?.cancelAmount != null && (
                    <div className="service-name " style={{ fontSize: "10px" }}>
                      {" "}
                      Số tiền chốt khi hủy:{formatMoney(row?.cancelAmount)}
                    </div>
                  )}
                </div>
              ),
            },
            {
              field: "createdBy",
              title: t("Người tạo"),
            },
            {
              field: "modifiedBy",
              title: t("Người sửa"),
            },
            {
              field: "note",
              title: t("Ghi chú"),
            },
            {
              field: "createDate",
              title: t("Số dư lưu trữ"),
              render: (val) => formatMoney(val?.retainedAmount),
            },
            {
              field: "createDate",
              title: t("Ngày tạo hệ thống"),
              render: (val) => getDateTime(val?.createDate),
            },
            {
              title: t("Mã đơn hàng cũ"),
              field: "codeOld",
              width: "50px",
              render: (val) =>
                val?.oldTreatmentPlanCard?.code ||
                val?.oldDrugOrder?.code ||
                val?.oldService?.code,
            },
          ].filter(Boolean)}
          dataPagination={{
            pageIndex: searchRegisterCard?.pageIndex,
            pageSize: searchRegisterCard?.pageSize,
            totalElements: pageRegisterCard?.totalElements,
            totalPages: pageRegisterCard?.totalPages,
            setPageIndex: (pageIndex) =>
              handleChangeFormSearchService({ pageIndex }),
            setPageSize: (pageSize) =>
              handleChangeFormSearchService({ pageSize }),
          }}
        />
      </Grid>
    </Grid>
  );
};

export default memo(observer(ListRegisterCard));
